import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const commentsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      getSubscriptions: query({
        query: () => `/subscriptions`,
        providesTags: ["Subscription"],
      }),

      getSubscriptionById: query({
        query: (id) => `/subscriptions/${id}`,
        providesTags: ["Subscription"],
      }),

      updateSubscriptionStatus: mutation({
        query: ({ id, status }) => ({
          url: `/subscriptions/${id}/status`,
          method: "PATCH",
          body: { status },
        }),
        invalidatesTags: (result, error, { id }) => [
          { type: "Subscription", id },
        ],
      }),

      updateSubscription: mutation({
        query: ({ id, plan }) => ({
          url: `/subscriptions/${id}/update-subscription`,
          method: "PUT",
          body: { plan }, // <--- send plan inside body
        }),
        invalidatesTags: ["User", "Subscription"],
      }),

      updateCard: mutation({
        query: (body) => ({
          url: "/subscriptions/update-card",
          method: "POST",
          body,
        }),
      }),

      createSubscription: mutation({
        query: (initial) => ({
          url: "/subscriptions/subscribe",
          method: "POST",
          body: {
            ...initial,
          },
        }),
        invalidatesTags: [{ type: "Subscription", id: "LIST" }],
        meta: { requiresAuth: false },
      }),

      createAdminInvite: mutation({
        query: (data) => ({
          url: "/subscriptions/invite",
          method: "POST",
          body: data,
        }),
      }),

      registerAdmin: builder.mutation({
        query: (data) => ({
          url: "/subscriptions/register-admin",
          method: "POST",
          body: data,
        }),
        meta: { requiresAuth: false },
      }),
    };
  },
});

export const {
  useCreateAdminInviteMutation,
  useRegisterAdminMutation,
  useUpdateCardMutation,
  useUpdateSubscriptionMutation,
  useGetSubscriptionsQuery,
  useGetSubscriptionByIdQuery,
  useCreateSubscriptionMutation,
  useUpdateSubscriptionStatusMutation,
} = commentsApiSlice;
